import { render, staticRenderFns } from "./SeleccionarAsientosConRegiones.vue?vue&type=template&id=5945195c"
import script from "./SeleccionarAsientosConRegiones.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosConRegiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports